// Vendor Libs
import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import {CircularProgress} from '@material-ui/core';

// Dish Tech React
import {useService} from '@dishtech-react/hooks';

// Components
import AssetDataTable from './asset-data-table';
import AddRuidsByEntryForm from './add-ruids-by-entry-form';

const SERVICE_KEY = 'ASSET';

const styles = {
  loading: {display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: 20},
  hide: {display: 'none'},
};

const AddAsset = ({onAdd, sort, reorderEnabled, rippleRoles}) => {
  const {fetching, serviceContent, registerService, unregisterService} = useService(SERVICE_KEY);
  const {assets, total} = serviceContent;

  useEffect(() => {
    registerService();
    return () => {
      unregisterService();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <AddRuidsByEntryForm />
      {fetching && (
        <>
          <div style={styles.loading}>Loading Assets...</div>
          <div style={styles.loading}>
            <CircularProgress />
          </div>
        </>
      )}

      <div style={fetching ? styles.hide : {}}>
        <AssetDataTable
          canAdd={true}
          data={assets}
          reorderEnabled={reorderEnabled}
          rippleRoles={rippleRoles}
          showSelectionControls={true}
          sort={sort}
          total={total}
          onAdd={onAdd}
        />
      </div>
    </>
  );
};

AddAsset.propTypes = {
  onAdd: PropTypes.func.isRequired,
  reorderEnabled: PropTypes.bool,
  rippleRoles: PropTypes.object,
  sort: PropTypes.bool,
};

export default AddAsset;
